(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon');
    module.directive('warningInfo', ['$rootScope', 'UserService', 'CallsService', 'Alert', 'HelperService', 'SharedAgendaService', WarningInfoDirectiveFn]);

    /* warning info directive */
    function WarningInfoDirectiveFn($rootScope, UserService, CallsService, Alert, HelperService, SharedAgendaService) {
        var directive = {
            link: link,
            restrict: 'E',
            replace: true,
            templateUrl: '/app/ringfoon/templates/warning-info.template.html',
            scope: true
        };
        return directive;

        function link(scope, element) {

            // ready to show
            scope.show = false;

            scope.warning = {
                content: null
            };

            var agendaId = null;

            activate();

            // activate directive
            function activate() {
                // only for Ringfoon
                if (!$rootScope.isRingfoon) {
                    element.remove();
                    return;
                } // if

                if (CallsService.outgoing.agendaId !== undefined) {
                    agendaId = CallsService.outgoing.agendaId;
                    warn(agendaId);
                }
                else {
                    SharedAgendaService.isLoading().then(function () {
                        agendaId = SharedAgendaService.data.currentAgenda.id;
                        warn(agendaId);
                    });
                }

            } // activate


            function warn(agendaId) {
                // load warning info of user
                UserService.warning(CallsService.outgoing.userId, agendaId).then(function (result) {
                    scope.warning.content = result || '';
                    scope.show = true;
                });
            }

            // save/update warning info
            scope.save = function () {
                HelperService.block(element);
                UserService.updateWarning(CallsService.outgoing.userId, agendaId, scope.warning.content).then(function (result) {
                    Alert.success(result);
                    HelperService.unblock(element);
                });
            };


        } // link
    }
})();